import React, { useState, useCallback, useMemo } from 'react';
import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from 'components/GlobalStyles';
import { ThemeContext } from './ThemeContext';
import { agentTheme } from './agentTheme';

ClassNameGenerator.configure(componentName => `muitrvl-${componentName}`);

const AgentThemeProvider = ({ agency, children }) => {
  const [overrides, setOverrides] = useState({});

  const setCustomization = useCallback((path, value, overrideMap = null) => {
    const next = overrideMap ? overrideMap : { [path]: value };
    setOverrides(prev => ({ ...prev, ...next }));
  }, []);

  const customizations = useMemo(() => ({ ...(agency || {}), ...overrides }), [agency, overrides]);

  const contextValue = useMemo(
    () => ({
      customizations,
      setCustomization,
    }),
    [customizations, setCustomization],
  );

  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={agentTheme}>
        <CssBaseline />
        <GlobalStyles />
        <ThemeContext.Provider value={contextValue}>{children}</ThemeContext.Provider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
};

export default AgentThemeProvider;
